import { render, staticRenderFns } from "./AfterLoginRealmSelect.vue?vue&type=template&id=74ce9568&scoped=true&"
import script from "./AfterLoginRealmSelect.vue?vue&type=script&lang=js&"
export * from "./AfterLoginRealmSelect.vue?vue&type=script&lang=js&"
import style0 from "./AfterLoginRealmSelect.vue?vue&type=style&index=0&id=74ce9568&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74ce9568",
  null
  
)

export default component.exports